import settings from "configs/settings";

const getCaptchaToken = () => {
    return new Promise((resolve, reject) => {
        window.grecaptcha.ready(function() {
            window.grecaptcha.execute(settings.captcha.siteKey, {action: 'submit'}).then(function(token) {
                resolve(token);
            });
          });
      });
}


export default getCaptchaToken;